import Image from 'next/image'

import styles from './sell-your-vehicle-banner.module.scss'
import { constants } from '@/lib/constants'

export const SellYourVehicleBanner = ({
  isVans,
  page,
  position,
}: {
  isVans: boolean
  page: string
  position: string
}) => {
  return (
    <a
      className={styles.main}
      href={`${constants.sellYourVehicleUrl.dealPage}${
        isVans
          ? `/sell-my-van?utm_source=leaseloco&utm_medium=affiliate&utm_campaign=${position}-${page}`
          : `/partner/leaseloco?utm_source=leaseloco&utm_medium=affiliate&utm_campaign=${position}-${page}`
      }`}>
      <div className={styles.content}>
        <span className={styles.title}>The easy way to sell your {isVans ? 'van' : 'car'}</span>
        <span className={styles.text}>Get the best price from 7,500+ dealers</span>
      </div>
      <div className={styles.end}>
        <Image
          src={`${constants.imageHost.assets}/affiliate/logo/motorway.svg`}
          width={90}
          height={18}
          alt="Motorway logo"
        />
        <span className={styles.button}>Value your {isVans ? 'van' : 'car'}</span>
      </div>
    </a>
  )
}
